import Axios from 'axios'

export default {
  getHeaaders(){
    if (localStorage.getItem("Authorization")) {
      return { headers: {Authorization: localStorage.getItem('Authorization')}};
    }
  },
  getData(url) {
    let header =  this.getHeaaders();
    var _this = this;
    return Axios.get(url, header)
    .then(responses => {
      return responses
    })
    .catch(function (error) {
      if (error.response.status != 'undefined' && error.response.status == 401) {
        window.location.href = "/logout";
      }
    });
  },
  postData(url, params) {
    var _this = this;
    let header =  this.getHeaaders();
    return Axios.post(url, params, header)
      .then(responses => {
        return responses
      })
      .catch(function (error) {
      if (error.response.status != 'undefined' && error.response.status == 401) {
        window.location.href = "/logout";
      }
    });
  }
}